<template>
  <div class="menu-container">
    <div class="item" v-for="item in items" :class="item.current?'active':''">
      <a :href="item.url">{{item.title}}</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "TabMenu",
  props: {
    items: {
      type: Object,
      default: {},
    }
  }
}
</script>

<style lang="scss" scoped>
  .menu-container {
    background: #FFFFFF;
    border: 1px solid #E9EBED;
    border-radius: 6px;
    .item {

      cursor: pointer;
      border-bottom: 1px solid #E9EBED;
      font-weight: 600;
      font-size: 16px;
      line-height: 22px;
      a {
        color: #000000;
        text-decoration: none;
        padding: 17px  20px;
        display: block;
      }
      &:last-child {
        border-bottom: none;
      }
      &.active, &:hover {
        background: #E9EBED;
      }
    }
  }

</style>